(function () {
  'use strict';

  /*
   * ---------------------------------------------------------
   * INITIALISE
   * ---------------------------------------------------------
   */

  function ready() {
    if (
      typeof L === 'undefined' ||
      typeof L.markerClusterGroup === 'undefined'
    ) {
      return setTimeout(ready, 50);
    }

    document
      .querySelectorAll('.store-locator')
      .forEach(initLocator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      ready
    );
  } else {
    ready();
  }


  /*
   * ---------------------------------------------------------
   * LOCATOR
   * ---------------------------------------------------------
   */

  function initLocator(root) {

    if (
      root.dataset.locatorInitialized === 'true'
    ) {
      return;
    }

    var sectionId =
      root.id.replace(
        'StoreLocator-',
        ''
      );

    var mapEl =
      document.getElementById(
        'StoreLocatorMap-' + sectionId
      );

    var listEl =
      document.getElementById(
        'StoreLocatorList-' + sectionId
      );

    var searchInput =
      document.getElementById(
        'StoreLocatorSearch-' + sectionId
      );

    var searchBtn =
      root.querySelector(
        '[data-action="search"]'
      );

    var geoBtn =
      root.querySelector(
        '[data-action="geolocate"]'
      );

    if (
      !mapEl ||
      !listEl ||
      !searchInput ||
      !searchBtn ||
      !geoBtn
    ) {
      return;
    }

    root.dataset.locatorInitialized = 'true';


    /*
     * ---------------------------------------------------------
     * SETTINGS
     * ---------------------------------------------------------
     */

    var defaultLat =
      parseFloat(
        root.dataset.defaultLat
      ) || -25.27;

    var defaultLng =
      parseFloat(
        root.dataset.defaultLng
      ) || 133.77;

    var defaultZoom =
      parseInt(
        root.dataset.defaultZoom,
        10
      ) || 4;

    var markerIconUrl =
      root.dataset.markerIconUrl || '';

    var analyticsEnabled =
      Boolean(markerIconUrl);


    /*
     * ---------------------------------------------------------
     * ANALYTICS
     * ---------------------------------------------------------
     */

    var locatorEngagedTracked = false;
    var findLocationTracked = false;

    function publishAnalyticsEvent(
      name,
      data
    ) {
      if (!analyticsEnabled) {
        return;
      }

      if (
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish ===
          'function'
      ) {
        Shopify.analytics.publish(
          name,
          data || {}
        );
      }
    }

    function trackLocatorEngaged(method) {
      if (
        !analyticsEnabled ||
        locatorEngagedTracked
      ) {
        return;
      }

      locatorEngagedTracked = true;

      publishAnalyticsEvent(
        'maxiblock:store_locator_engaged',
        {
          method: method
        }
      );
    }

    function trackFindLocation(method) {
      if (
        !analyticsEnabled ||
        findLocationTracked
      ) {
        return;
      }

      findLocationTracked = true;

      publishAnalyticsEvent(
        'maxiblock:find_location',
        {
          method: method
        }
      );
    }


    /*
     * ---------------------------------------------------------
     * MAP
     * ---------------------------------------------------------
     */

    var map =
      L.map(mapEl).setView(
        [
          defaultLat,
          defaultLng
        ],
        defaultZoom
      );

    L.tileLayer(
      'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        maxZoom: 19,

        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }
    ).addTo(map);


    /*
     * ---------------------------------------------------------
     * PRODUCT MARKER
     * ---------------------------------------------------------
     */

    var productIcon = null;

    if (markerIconUrl) {
      productIcon =
        L.icon({
          iconUrl:
            markerIconUrl,

          iconSize:
            [42, 58],

          iconAnchor:
            [21, 58],

          popupAnchor:
            [0, -54],

          className:
            'store-locator__product-marker'
        });
    }


    /*
     * ---------------------------------------------------------
     * MARKER CLUSTERS
     * ---------------------------------------------------------
     */

    var clusterOptions = {
      chunkedLoading: true,
      maxClusterRadius: 50
    };

    if (markerIconUrl) {

      clusterOptions.iconCreateFunction =
        function (cluster) {

          var count =
            cluster.getChildCount();

          var sizeClass =
            'store-locator__cluster--small';

          var size = 40;

          if (count >= 10) {
            sizeClass =
              'store-locator__cluster--medium';

            size = 44;
          }

          if (count >= 50) {
            sizeClass =
              'store-locator__cluster--large';

            size = 48;
          }

          return L.divIcon({
            html:
              '<span class="store-locator__cluster-count">' +
              count +
              '</span>',

            className:
              'store-locator__cluster ' +
              sizeClass,

            iconSize:
              [size, size],

            iconAnchor:
              [
                size / 2,
                size / 2
              ]
          });
        };
    }

    var cluster =
      L.markerClusterGroup(
        clusterOptions
      );

    var locations = [];
    var markersById = {};


    /*
     * ---------------------------------------------------------
     * LOAD STORE LOCATIONS
     * ---------------------------------------------------------
     */

    fetch(
      root.dataset.locationsUrl
    )

      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Could not load store locations. HTTP ' +
            response.status
          );
        }

        return response.json();
      })

      .then(function (data) {

        if (!Array.isArray(data)) {
          throw new Error(
            'Store location JSON is not an array.'
          );
        }

        locations =
          data.filter(
            function (loc) {
              return (
                typeof loc.lat ===
                  'number' &&
                typeof loc.lng ===
                  'number'
              );
            }
          );

        locations.forEach(
          function (loc, index) {
            loc._id = index;
          }
        );

        addMarkers();
        renderList(locations);
      })

      .catch(function (error) {

        listEl.innerHTML =
          '<p class="store-locator__status">' +
          'Could not load locations. Please try again later.' +
          '</p>';

        console.error(
          'Store locator error:',
          error
        );
      });


    /*
     * ---------------------------------------------------------
     * ADD MAP MARKERS
     * ---------------------------------------------------------
     */

    function addMarkers() {

      locations.forEach(
        function (loc) {

          var markerOptions = {};

          if (productIcon) {
            markerOptions.icon =
              productIcon;
          }

          var marker =
            L.marker(
              [
                loc.lat,
                loc.lng
              ],
              markerOptions
            );

          marker.bindPopup(
            popupHtml(loc)
          );

          marker.on(
            'click',
            function () {

              trackLocatorEngaged(
                'map_marker'
              );

              highlightInList(
                loc._id
              );
            }
          );

          cluster.addLayer(
            marker
          );

          markersById[
            loc._id
          ] = marker;
        }
      );

      map.addLayer(
        cluster
      );
    }


    /*
     * ---------------------------------------------------------
     * STORE POPUP
     * ---------------------------------------------------------
     */

    function popupHtml(loc) {

      var parts = [
        '<strong class="store-locator__popup-name">' +
        escapeHtml(loc.name) +
        '</strong>'
      ];

      if (loc.address) {

        parts.push(
          '<div class="store-locator__popup-address">' +
          escapeHtml(
            loc.address
          ) +
          '</div>'
        );
      }

      if (loc.phone) {

        parts.push(
          '<div class="store-locator__popup-phone">' +
          '<a href="tel:' +
          escapeHtml(
            loc.phone
          ) +
          '">' +
          escapeHtml(
            loc.phone
          ) +
          '</a>' +
          '</div>'
        );
      }

      if (loc.hours) {

        parts.push(
          '<div class="store-locator__popup-hours">' +
          escapeHtml(
            loc.hours
          ) +
          '</div>'
        );
      }

      if (loc.website) {

        parts.push(
          '<div class="store-locator__popup-website">' +
          '<a href="' +
          escapeHtml(
            loc.website
          ) +
          '" target="_blank" rel="noopener">' +
          'Visit website' +
          '</a>' +
          '</div>'
        );
      }

      parts.push(
        '<div class="store-locator__popup-directions">' +

        '<a ' +
        'class="store-locator__directions-link" ' +

        'href="https://www.google.com/maps/dir/?api=1&destination=' +

        encodeURIComponent(
          loc.lat +
          ',' +
          loc.lng
        ) +

        '" target="_blank" rel="noopener">' +

        'Get directions' +

        '</a>' +

        '</div>'
      );

      return parts.join('');
    }


    /*
     * ---------------------------------------------------------
     * STORE LIST
     * ---------------------------------------------------------
     */

    function renderList(
      list,
      origin
    ) {

      if (!list.length) {

        listEl.innerHTML =
          '<p class="store-locator__status">' +
          'No locations found.' +
          '</p>';

        return;
      }

      var html =
        list.map(
          function (loc) {

            var distanceHtml = '';

            if (origin) {

              distanceHtml =
                '<span class="store-locator__distance">' +

                formatDistance(
                  haversine(
                    origin,
                    loc
                  )
                ) +

                '</span>';
            }

            return (
              '<button ' +
              'type="button" ' +
              'class="store-locator__item" ' +
              'data-id="' +
              loc._id +
              '">' +

              '<span class="store-locator__item-name">' +

              '<span>' +
              escapeHtml(
                loc.name
              ) +
              '</span>' +

              distanceHtml +

              '</span>' +

              (
                loc.address
                  ? '<span class="store-locator__item-address">' +
                    escapeHtml(
                      loc.address
                    ) +
                    '</span>'
                  : ''
              ) +

              '</button>'
            );
          }
        ).join('');

      listEl.innerHTML =
        html;

      listEl
        .querySelectorAll(
          '.store-locator__item'
        )
        .forEach(
          function (btn) {

            btn.addEventListener(
              'click',
              function () {

                var id =
                  parseInt(
                    btn.dataset.id,
                    10
                  );

                trackLocatorEngaged(
                  'store_list'
                );

                focusLocation(
                  id
                );
              }
            );
          }
        );
    }


    /*
     * ---------------------------------------------------------
     * FOCUS STORE
     * ---------------------------------------------------------
     */

    function focusLocation(id) {

      var marker =
        markersById[id];

      if (!marker) {
        return;
      }

      cluster.zoomToShowLayer(
        marker,
        function () {
          marker.openPopup();
        }
      );

      highlightInList(
        id
      );
    }


    /*
     * ---------------------------------------------------------
     * HIGHLIGHT STORE IN LIST
     * ---------------------------------------------------------
     */

    function highlightInList(id) {

      listEl
        .querySelectorAll(
          '.store-locator__item'
        )
        .forEach(
          function (el) {

            el.classList.toggle(
              'is-active',

              parseInt(
                el.dataset.id,
                10
              ) === id
            );
          }
        );

      var active =
        listEl.querySelector(
          '.is-active'
        );

      if (active) {

        active.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    }


    /*
     * ---------------------------------------------------------
     * SEARCH
     * ---------------------------------------------------------
     */

    function doSearch() {

      var q =
        searchInput
          .value
          .trim();

      if (!q) {
        return;
      }

      trackLocatorEngaged(
        'search'
      );

      var url =
        'https://nominatim.openstreetmap.org/search' +
        '?format=json' +
        '&limit=1' +
        '&countrycodes=au' +
        '&q=' +
        encodeURIComponent(q);

      listEl.innerHTML =
        '<p class="store-locator__status">' +
        'Searching…' +
        '</p>';

      fetch(
        url,
        {
          headers: {
            Accept:
              'application/json'
          }
        }
      )

        .then(
          function (response) {

            if (!response.ok) {

              throw new Error(
                'Search request failed.'
              );
            }

            return response.json();
          }
        )

        .then(
          function (results) {

            if (!results.length) {

              listEl.innerHTML =
                '<p class="store-locator__status">' +
                'Address not found. Try a postcode or suburb.' +
                '</p>';

              return;
            }

            var origin = {

              lat:
                parseFloat(
                  results[0].lat
                ),

              lng:
                parseFloat(
                  results[0].lon
                )
            };

            trackFindLocation(
              'search'
            );

            handleOrigin(
              origin
            );
          }
        )

        .catch(
          function (error) {

            console.error(
              'Store search error:',
              error
            );

            listEl.innerHTML =
              '<p class="store-locator__status">' +
              'Search failed. Please try again.' +
              '</p>';
          }
        );
    }


    /*
     * ---------------------------------------------------------
     * SORT BY DISTANCE + FIT MAP TO NEAREST STORES
     * ---------------------------------------------------------
     */

    function handleOrigin(origin) {

      var sorted =
        locations
          .slice()
          .sort(
            function (a, b) {

              return (
                haversine(
                  origin,
                  a
                ) -

                haversine(
                  origin,
                  b
                )
              );
            }
          );

      renderList(
        sorted,
        origin
      );

      /*
       * Show searched location + 5 nearest stores.
       */

      var nearest =
        sorted.slice(
          0,
          5
        );

      if (nearest.length) {

        var bounds =
          L.latLngBounds(
            nearest.map(
              function (loc) {
                return [
                  loc.lat,
                  loc.lng
                ];
              }
            )
          );

        /*
         * Include searched postcode/suburb/location
         * in the visible area as well.
         */

        bounds.extend([
          origin.lat,
          origin.lng
        ]);

        map.fitBounds(
          bounds,
          {
            padding:
              [40, 40],

            maxZoom:
              12
          }
        );

        /*
         * Open closest result.
         */

        setTimeout(
          function () {

            focusLocation(
              nearest[0]._id
            );

          },
          300
        );
      }
    }


    /*
     * ---------------------------------------------------------
     * SEARCH BUTTON
     * ---------------------------------------------------------
     */

    searchBtn.addEventListener(
      'click',
      doSearch
    );


    /*
     * ---------------------------------------------------------
     * ENTER KEY
     * ---------------------------------------------------------
     */

    searchInput.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Enter'
        ) {

          event.preventDefault();

          doSearch();
        }
      }
    );


    /*
     * ---------------------------------------------------------
     * USE MY LOCATION
     * ---------------------------------------------------------
     */

    geoBtn.addEventListener(
      'click',
      function () {

        if (
          !navigator.geolocation
        ) {
          return;
        }

        trackLocatorEngaged(
          'geolocation'
        );

        geoBtn.disabled = true;

        navigator.geolocation
          .getCurrentPosition(

            function (position) {

              geoBtn.disabled =
                false;

              trackFindLocation(
                'geolocation'
              );

              handleOrigin({
                lat:
                  position.coords
                    .latitude,

                lng:
                  position.coords
                    .longitude
              });
            },

            function () {

              geoBtn.disabled =
                false;
            }
          );
      }
    );


    /*
     * ---------------------------------------------------------
     * GET DIRECTIONS
     * ---------------------------------------------------------
     */

    mapEl.addEventListener(
      'click',
      function (event) {

        var link =
          event.target.closest(
            '.store-locator__directions-link'
          );

        if (!link) {
          return;
        }

        trackLocatorEngaged(
          'directions'
        );

        trackFindLocation(
          'directions'
        );
      }
    );
  }


  /*
   * ---------------------------------------------------------
   * HAVERSINE DISTANCE
   * ---------------------------------------------------------
   */

  function haversine(a, b) {

    var R = 6371;

    var dLat =
      toRad(
        b.lat - a.lat
      );

    var dLng =
      toRad(
        b.lng - a.lng
      );

    var lat1 =
      toRad(
        a.lat
      );

    var lat2 =
      toRad(
        b.lat
      );

    var x =
      Math.sin(
        dLat / 2
      ) *
      Math.sin(
        dLat / 2
      ) +

      Math.sin(
        dLng / 2
      ) *
      Math.sin(
        dLng / 2
      ) *
      Math.cos(
        lat1
      ) *
      Math.cos(
        lat2
      );

    return (
      2 *
      R *
      Math.asin(
        Math.sqrt(x)
      )
    );
  }


  function toRad(degrees) {

    return (
      degrees *
      Math.PI /
      180
    );
  }


  /*
   * ---------------------------------------------------------
   * FORMAT DISTANCE
   * ---------------------------------------------------------
   */

  function formatDistance(km) {

    if (km < 1) {

      return (
        Math.round(
          km * 1000
        ) +
        ' m'
      );
    }

    if (km < 10) {

      return (
        km.toFixed(1) +
        ' km'
      );
    }

    return (
      Math.round(km) +
      ' km'
    );
  }


  /*
   * ---------------------------------------------------------
   * ESCAPE HTML
   * ---------------------------------------------------------
   */

  function escapeHtml(value) {

    return String(
      value == null
        ? ''
        : value
    )

      .replace(
        /&/g,
        '&amp;'
      )

      .replace(
        /</g,
        '&lt;'
      )

      .replace(
        />/g,
        '&gt;'
      )

      .replace(
        /"/g,
        '&quot;'
      )

      .replace(
        /'/g,
        '&#39;'
      );
  }


  /*
   * ---------------------------------------------------------
   * SHOPIFY THEME EDITOR
   * ---------------------------------------------------------
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var root =
        event.target
          .querySelector(
            '.store-locator'
          );

      if (
        root &&
        typeof L !==
          'undefined' &&
        typeof L.markerClusterGroup !==
          'undefined'
      ) {

        initLocator(
          root
        );
      }
    }
  );

})();